<template>
    <form method="post">
        <label for="input-justification">Quelles sont vos motivations pour rejoindre le SUP-H ? *</label>
        <textarea
            :class="v && isError(v.motivations) ? 'error' : null"
            v-model="state.motivations"
            id="input-justification"
            cols="30"
            rows="10"
            required
        ></textarea>
        <ErrorMessage v-if="v && isError(v.motivations)" message="Ce champ est nécessaire" />

        <div class="check">
            <input v-model="checkbox.chart" type="checkbox" id="input-checkbox-chart" />

            <label for="input-checkbox-chart">
                En adhérent au SUP-H, vous vous engagez à respecter la Charte de Déontologie du SUP-H
                et le Règlement Intérieur
            </label>
        </div>

        <div>
            <h3>Confidentialité des données</h3>
            <div class="check">
                <input
                    v-model="checkbox.confidentiality"
                    type="checkbox"
                    name="checkbox"
                    id="checkbox-confidentiality"
                />
                <label for="checkbox-confidentiality">
                    Je consens à ce que le SUP-H conserve ces informations pour répondre à ma demande d'adhésion.
                    Ces données sont utilisées également à des fins statistiques.
                    Ces données ne feront l'objet d'aucune publication.
                </label>
            </div>
        </div>

        <div class="btn">
            <button
                id="send-data"
                :class="!disabledButton ? 'isDisabled' : null"
                :disabled="disabledButton"
                @click.prevent="sendData()"
            >Envoyer ma demande d'adhésion</button>
        </div>
    </form>
</template>

<script>
import { reactive, computed } from "vue";
import { state, send } from "../../store";
import { isError } from '../../validation';
import ErrorMessage from '../errors/ErrorMessage.vue';

export default {
    name: "FourthStep",
    components: { ErrorMessage },
    props: {
        v: {
            type: Object
        }
    },
    setup() {
        const checkbox = reactive({
            chart: false,
            confidentiality: false
        });

        const disabledButton = computed(() => {
            if (checkbox.chart === true && checkbox.confidentiality === true && state.motivations.length > 0) {
                return false;
            }
            return true;
        })

        const sendData = () => {
            send();
        }

        return { checkbox, state, disabledButton, sendData, isError };
    }
}
</script>

<style lang='scss' scoped>
@import "../../scss/variables";

textarea {
    resize: vertical;
    min-height: 16px;
    max-height: 350px;
}

.check {
    margin-top: 1em;
    display: flex;
    align-items: center;

    label {
        padding-left: 0.5rem;
    }
}

.div-btn {
    @include buttonStyle($base-color, 2px solid $base-color, white);
}

.isDisabled:hover {
    background-color: #643773;
    color: white;
}
</style>
